























































































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { ExceptionalDay, ApiError, Extra } from '@/api';
import { snackModule, authModule } from '@/store';
import { Route } from 'vue-router';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import CurrencyField from '@/components/CurrencyField.vue';
import RelCheckbox from '@/components/RelCheckbox.vue';

@Component({
  components: {
    ConfirmDialog,
    CurrencyField,
    RelCheckbox,
  },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  loading: boolean = false;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  day: ExceptionalDay | null = null;

  dateMenu: boolean = false;

  nextFn: (() => void) | null = null;
  leaveConfirmDialog: boolean = false;
  confirmLeaveContent: string =
    'Are you sure you would like to leave? Any unsaved changes will be lost.';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  get dayId() {
    return this.$route.params.dayId;
  }

  extraScopeFactory() {
    return Extra.includes([]);
  }

  orderRates() {
    if (!this.day || !this.day.exceptionalRates) {
      return;
    }

    this.day.exceptionalRates.sort((a, b) => {
      if (a.lot.name > b.lot.name) {
        return 1;
      }
      if (a.lot.name < b.lot.name) {
        return -1;
      }
      return 0;
    });
  }

  back() {
    this.$router.back();
  }

  beforeRouteLeave(to: Route, from: Route, next: (args?: any) => void) {
    if (this.day && this.day.isDirty()) {
      this.nextFn = next;
      this.leaveConfirmDialog = true;
      next(false);
    } else {
      next();
    }
  }

  leave() {
    if (this.nextFn) {
      this.nextFn();
    }
  }

  async save() {
    if (!this.day) {
      return;
    }

    if (this.day.exceptionalRates) {
      this.day.exceptionalRates.forEach(async rate => {
        try {
          await rate.save();
        } catch (err) {
          // Error
        }
      });
    }

    try {
      await this.day.save({ with: ['unavailableExtras.id'] });
      if (this.$route.name === 'admin-days-add' && this.day && this.day.id) {
        this.$router.push({
          name: 'admin-days-edit',
          params: { dayId: this.day.id },
        });

        this.day = (
          await ExceptionalDay.includes(['exceptionalRates.lot']).find(
            this.dayId,
          )
        ).data;
        this.orderRates();
        snackModule.showSnackbar('Day Created');
      } else {
        snackModule.showSnackbar('Day Updated');
      }
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async mounted() {
    if (this.$route.name === 'admin-days-edit' && this.dayId) {
      try {
        this.day = (
          await ExceptionalDay.includes(['exceptionalRates.lot']).find(
            this.dayId,
          )
        ).data;
        this.orderRates();
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Exceptional day not found');
      }
    } else {
      this.day = new ExceptionalDay();
    }
  }
}
